import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "综艺频道", to: "/category/variety" },
];

const infoLinks = [
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩" },
  { icon: "ri-youtube-line", label: "视频号" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
                CC
              </span>
              <span className="font-heading font-bold text-xl">CC视频</span>
            </div>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              精选影视视频内容平台，聚合电影、电视剧、综艺资源与最新影视资讯，为影视爱好者提供清晰的浏览与发现体验。
            </p>
          </div>

          <div>
            <h3 className="font-medium text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-medium text-background-50 mb-4">关于与帮助</h3>
            <ul className="space-y-2.5">
              {infoLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-medium text-background-50 mb-4">关注我们</h3>
            <div className="flex items-center gap-3">
              {socials.map((s) => (
                <span
                  key={s.label}
                  aria-label={s.label}
                  title={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </span>
              ))}
            </div>
            <p className="mt-4 text-sm text-background-300">
              合作邮箱：partner@ccvideo.demo
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 CC视频 版权所有 · 本站内容均为演示数据，仅供展示
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-background-400">
            <span className="cursor-pointer hover:text-background-200">服务条款</span>
            <span className="cursor-pointer hover:text-background-200">隐私政策</span>
            <span className="cursor-pointer hover:text-background-200">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}